module.exports = __webpack_public_path__ + "fonts/5cce95c8e3b43a9667e43111eb13b31e.svg";